// extracted by mini-css-extract-plugin
export default {"wrapper":"JadwalKerja_wrapper__fdMie","title":"JadwalKerja_title__i2hu1","subTitle":"JadwalKerja_subTitle__waS3v","button":"JadwalKerja_button__tz6-U"};